import { SecretRow } from '@/components/secret-row';
import { useCopyToClipboard } from '@/shared/hooks/use-copy-to-clipboard';
import { Button } from '@/shared/ui/button';
import { useCopyCodexSecret } from '../hooks/use-copy-codex-secret';
import { maskSigningSecret } from '../model/claude-key';

type CodexWebhookRowsProps = { webhookUrl: string; secretHint: string | null };

/** The URL and secret people paste into their Agents API environment (first run). */
export function CodexWebhookRows({ webhookUrl, secretHint }: CodexWebhookRowsProps) {
  const { copy, isCopied } = useCopyToClipboard();
  const { copySecret, isCopied: isSecretCopied, isRevealing } = useCopyCodexSecret();
  return (
    <>
      <SecretRow
        value={webhookUrl}
        action={
          <Button variant="ghost" size="sm" onClick={() => void copy(webhookUrl)}>
            {isCopied ? 'Copied' : 'Copy'}
          </Button>
        }
      />
      <SecretRow
        value={maskSigningSecret(secretHint)}
        action={
          <Button
            variant="ghost"
            size="sm"
            isLoading={isRevealing}
            onClick={() => void copySecret()}
          >
            {isSecretCopied ? 'Copied' : 'Copy secret'}
          </Button>
        }
      />
    </>
  );
}
